<template>
  <div class="enterpriseExplain">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
            <div class="search_con m_flex_box flex_vc">入网须知</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div class="word_title">
      线上办理入网前，请确认以下信息和材料(上传材料格式均为jpg)
    </div>
    <div class="word_mian">
      <div>1、工商营业执照</div>
      <p>(1)工商营业执照正本和副本复印件各一份,并加盖公章后扫描备用。</p>
      <p>(2)工商营业执照正本和副本原件的扫描件。</p>
    </div>
    <div class="word_mian">
      <div>2、房地产开发企业资质证书</div>
      <p>(1)资质证书正本和副本的复印件各一份，并加盖公章后扫描备用。</p>
      <p>(2)资质证书正本和副本原件的扫描件。</p>
    </div>
    <div class="word_mian">
      <div>3、操作员资料</div>
      <p>(1)姓名、联系电话、身份证号。</p>
      <p>(2)身份证正反两面拍照后备用。</p>
      <p>(3)操作员2寸电子照片一张。</p>
    </div>
    <div class="word_mian">
      4、开发企业法人代表身份证复印件（正反面在一张），加盖公章后扫码备用。
    </div>
    <div class="word_mian">
      5、填写《商品房预（销）售合同网上登记备案管理系统入网申请书》，打印后加盖公章，扫描备用。
      <p class="download">
        <a @click="upload1">点击下载模板</a>
      </p>
    </div>
    <div class="word_mian">
      6、填写《商品房预（销）售合同网上登记备案管理系统操作员登记表》，打印后加盖公章，扫描备用。
      <p class="download">
        <a @click="upload2">点击下载模板</a>
      </p>
    </div>
    <div class="word_mian">
      7、委托书：写明某某公司委托某某办理入网手续，打印后加盖公章，扫描备用。
    </div>
    
    <div class="word_title">审核通过后，请准备好以下待交件(纸质复印件)并及时交件</div>
    <div class="word_mian">
      <div>1、工商营业执照复印件，并加盖公章。</div>
      <div>2、房地产开发企业资质证书复印件，并加盖公章。</div>
      <div>3、操作员身份证正反两面复印件。</div>
      <div>4、开发企业法人代表身份证正反两面复印件，并加盖公章。</div>
      <div>
        5、《商品房预(销)售合同网上登记备案管理系统入网申请书》,打印后加盖公章。
      </div>
      <div>
        6、《商品房预(销)售合同网上登记备案管理系统操作员登记表》,打印后加盖公章。
      </div>
      <div>7、委托书打印后加盖公章。</div>
    </div>
    <div class="word_title">待交件的交件方式：</div>
    <div class="word_mian">
      <div>1、方式一：现场交件。请携带以上待交件，前往徐州市鼓楼区坝子街9号中和大厦1513室现场交付纸质文件。</div>
      <div>2、方式二：邮寄交件。邮寄地址为徐州市鼓楼区坝子街9号中和大厦1513室，收件人张琨，电话83601286。</div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "enterpriseAccess",
  data() {
    return {
      isAppOne: sessionStorage.getItem("isAppOne") || false,
      cardNo: "",
      phone: "",
      codeTime: 120,
    };
  },
  mounted() {},
  methods: {
    upload1() {
      if (this.isAppOne) {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.downloadApplyTemplate(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.downloadApplyTemplate.postMessage(null);
        }
      } else {
        window.location.href =
          "https://www.xzhouse.com.cn/house/xzh_static/sDown/SystemAccessApplication.doc";
      }
    },
    upload2() {
      if (this.isAppOne) {
      let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.downloadRegisterTemplate(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.downloadRegisterTemplate.postMessage(
            null
          );
        }
      } else {
        window.location.href =
          "https://www.xzhouse.com.cn/house/xzh_static/sDown/OperatorRegistrationForm.doc";
      }
    },
    goback() {
      this.$router.go(-1);
    },
    onSubmit(values) {},
    sendCode() {
      if (!this.cardNo) {
        this.$toast("请输入正确的验证码");
        return;
      } else if (!this.phone) {
        this.$toast("请输入正确的手机号");
        return;
      }
      if (this.codeTime === 120) {
        this.$http
          .post(
            "cms/onlineUser/permit/getMessageCode_login.do",
            qs.stringify({
              cardNo: this.cardNo,
              phone: this.phone,
            })
          )
          .then((res) => {
            this.$toast(res.msg);
            if (res.success) {
              this.codeTime -= 1;
              let setTimer = setInterval(() => {
                if (this.codeTime > 0) {
                  this.codeTime -= 1;
                } else {
                  this.codeTime = 120;
                  clearInterval(setTimer);
                }
              }, 1000);
            }
          });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    console;
    if (to.name === "MechanismDetail") {
      this.$store.dispatch("saveView", ["AnnounceMechanism"]).then(() => {
        next();
      });
    } else {
      this.$store.dispatch("saveView", []).then(() => {
        next();
      });
    }
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.1rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    font-weight: bolder;
    justify-content: center;
    width: 5.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.enterpriseExplain {
  padding-left: 0.2rem;
  padding-top: 0.3rem;
  .word_title {
    font-size: 0.3rem;
    font-weight: bold;
  }
  .word_mian {
    padding-top: 0.2rem;
    font-size: 0.3rem;
    .download {
      a {
        font-weight: bold;
        color: #2f72f5;
      }
    }
    p {
      padding-top: 0.1rem;
      padding-left: 0.2rem;
    }
  }
}
</style>